import React, { useEffect, useState } from "react";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Swal from "sweetalert2";
import { GetASD, GroupByForeignKey, GroupByPropCheck, GroupByProps } from "../../ReporteCobranza/Actions/GetContainer";
import { EjercicioByRange } from "../../ReporteCobranza/Helper/EjercicioByRange";
import { PeriodoSelect } from "../../ReporteCobranza/Helper/PeriodoSelect";

// Filtro del listado global de condonaciones (idcliente=0, solo accesible desde el dashboard) —
// mismo patrón que FiltroDashboardCobranza/FiltroRecuperacionCartera (ejercicio, periodo, región,
// sucursal), sin el campo Responsable.
export const FiltroCondonacionesGlobal = ({ onExecute, boxState, onBoxChange, sucursales }) => {
    const [openModal, setOpenModal] = useState(false);
    const storedState = JSON.parse(localStorage.getItem("state")) || {};
    const newejercicio = storedState.ejercicio || new Date().getFullYear();
    const newperiodo = storedState.periodo || new Date().getMonth() + 1;

    const [state, setState] = useState({
        adr: Array.isArray(storedState?.adr) && storedState?.adr?.some((item) => item.checked)
            ? storedState.adr.filter((item) => item.checked).map(({ idadr, adr }) => ({ idadr, adr }))
            : [],
        sucursal: Array.isArray(storedState?.sucursal) && storedState?.sucursal?.some((item) => item.checked)
            ? storedState.sucursal.filter((item) => item.checked).map(({ idsucursal, sucursal }) => ({ idsucursal, sucursal }))
            : [],
        ejercicio: newejercicio,
        periodo: newperiodo,
    });
    const { data, adr, sucursal, departamento } = state;

    const onOpenModal = () => {
        const container = document.getElementById("mdlFiltros-modal-condonaciones");
        if (!container) return;
        if (openModal) {
            container.style.display = "flex";
            setOpenModal(false);
        } else {
            container.style.display = "none";
            setOpenModal(true);
        }
    };

    useEffect(() => {
        GetASD()
            .then((res) => {
                setState((prev) => ({ ...prev, data: res }));

                const sucursalActiva = storedState.sucursal?.filter((s) => s.checked) || [];
                const sucursalesSeleccionadas = sucursalActiva.length > 0
                    ? sucursalActiva
                    : [
                        ...new Map(
                            (sucursales || []).map((s) => [
                                s.idsucursal,
                                { idsucursal: s.idsucursal, sucursal: s.sucursal || s.nombreSucursal || "" },
                            ])
                        ).values(),
                    ];

                onBoxChange("pv", {
                    adr: GroupByProps(res, ["idadr", "adr"]),
                    sucursal: sucursalesSeleccionadas,
                    departamento: [],
                });
            })
            .catch((err) => console.log(err));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const idsSucursalPermitidas = [...new Set((sucursales || []).map((s) => String(s.idsucursal)))];
    const sucursalFiltrada = sucursal.filter((item) => idsSucursalPermitidas.includes(item.idsucursal));
    const adrFiltrado = adr?.filter((itemAdr) =>
        data?.some((d) => String(d.idadr) === String(itemAdr.idadr) && idsSucursalPermitidas.includes(String(d.idsucursal)))
    );

    useEffect(() => {
        if (!data || data.length === 0) return;

        let newadr = GroupByPropCheck(data, ["idadr", "adr"], false);
        let newsucursal = GroupByPropCheck(data, ["idsucursal", "sucursal"], false);
        let newdepartamento = GroupByPropCheck(data, ["iddepartamento", "departamento"], false);

        const savedState = JSON.parse(localStorage.getItem("state")) || {};

        if (Array.isArray(savedState.adr)) {
            newadr = newadr.map((item) => ({
                ...item,
                checked: savedState?.adr?.some((a) => a.idadr === item.idadr && a.checked),
            }));
        }
        if (Array.isArray(savedState.sucursal)) {
            newsucursal = newsucursal.map((item) => ({
                ...item,
                checked: savedState?.sucursal?.some((s) => s.idsucursal === item.idsucursal && s.checked),
            }));
        }

        setState((prev) => ({ ...prev, adr: newadr, sucursal: newsucursal, departamento: newdepartamento }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    const onCargar = () => {
        if (!state.ejercicio) {
            Swal.fire("CONDONACIÓN DE INTERÉS", "Favor de seleccionar el ejercicio", "warning");
            return;
        }
        if (!state.periodo) {
            Swal.fire("CONDONACIÓN DE INTERÉS", "Favor de seleccionar el periodo", "warning");
            return;
        }
        onOpenModal();
        onExecute(
            state.ejercicio,
            state.periodo,
            state.sucursal.filter((item) => item.checked),
            state.adr.filter((item) => item.checked)
        )
            .then(() => {})
            .catch((error) => {
                Swal.fire("CONDONACIÓN DE INTERÉS", JSON.stringify(error), "error");
            });
    };

    const labelclick = ({ target }) => {
        target.parentNode.firstChild.click();
    };

    const selectedClick = ({ target }, index) => {
        switch (target.name) {
            case "chk-adr": {
                const newarray = adr;
                newarray[index].checked = target.checked;

                let newarrarsucursal = [];
                let newarraydepartamento = [];
                let adrActive = [];
                newarray.forEach((item) => {
                    if (item.checked) {
                        adrActive = [...adrActive, { idadr: item.idadr, adr: item.adr }];
                        newarrarsucursal = newarrarsucursal.concat(
                            GroupByForeignKey(data, "idadr", item.idadr, ["idsucursal", "sucursal"])
                        );
                        newarraydepartamento = newarraydepartamento.concat(
                            GroupByForeignKey(data, "idadr", item.idadr, ["iddepartamento", "departamento"])
                        );
                    }
                });
                onBoxChange("pv", { adr: adrActive, sucursal: [], departamento: [] });
                setState({
                    ...state,
                    adr: newarray,
                    sucursal: newarrarsucursal.length === 0
                        ? GroupByPropCheck(data, ["idsucursal", "sucursal"], false)
                        : GroupByPropCheck(newarrarsucursal, ["idsucursal", "sucursal"], false),
                    departamento: newarraydepartamento.length === 0
                        ? GroupByPropCheck(data, ["iddepartamento", "departamento"], false)
                        : GroupByPropCheck(newarraydepartamento, ["iddepartamento", "departamento"], false),
                });
                break;
            }
            case "chk-sucursal": {
                const newarray = sucursalFiltrada;
                newarray[index].checked = target.checked;

                let newarraydepartamento = [];
                let sucursalactiva = [];
                newarray.forEach((item) => {
                    if (item.checked) {
                        sucursalactiva = [...sucursalactiva, { idsucursal: item.idsucursal, sucursal: item.sucursal }];
                        newarraydepartamento = newarraydepartamento.concat(
                            GroupByForeignKey(data, "idsucursal", item.idsucursal, ["iddepartamento", "departamento"])
                        );
                    }
                });
                onBoxChange("pv", { adr: boxState.pv.adr, sucursal: sucursalactiva, departamento: [] });
                setState({
                    ...state,
                    sucursal: newarray,
                    departamento: newarraydepartamento.length === 0
                        ? GroupByPropCheck(data, ["iddepartamento", "departamento"], false)
                        : GroupByPropCheck(newarraydepartamento, ["iddepartamento", "departamento"], false),
                });
                break;
            }
            default:
                break;
        }
    };

    const onChange = ({ target }) => {
        setState({ ...state, [target.name]: target.value });
        onBoxChange(target.name, target.value);
    };

    return (
        <div className="filtros-pedidos-facturados">
            <div className="reporte-buro-credito-filtrado" onClick={onOpenModal}>
                <FilterAltIcon /> Filtrar
            </div>
            <div className="mdl-filtro-resumen-cartera" id="mdlFiltros-modal-condonaciones">
                <PlantillaScreen titulo="Filtro" className_main={1} className="modal-filtro-resumen-cartera-mensual">
                    <div className="filtro-soy-el-titulo-header" onClick={onOpenModal}>
                        X
                    </div>
                    <div className="modal-filtro-resumen-cartera-mensual-container">
                        <div className="modal-filtro-resumen-cartera-mensual-container-filtros">
                            <div className="filtro-tiempo-tipo">
                                <div className="filtro-group">
                                    <label>Ejercicio</label>
                                    <EjercicioByRange name="ejercicio" value={state.ejercicio} onChange={onChange} />
                                    <label>Periodo</label>
                                    <PeriodoSelect name="periodo" value={state.periodo} onChange={onChange} />
                                </div>
                                <div className="mdlFiltros-modal-acciones-guardar" onClick={onCargar}>
                                    Cargar
                                </div>
                            </div>
                            <div className="filtro-adr">
                                <div className="title title-adr">REGION</div>
                                {adrFiltrado?.map((item, index) => (
                                    <div key={`${item}-${index}`} className="chk-groups">
                                        <input
                                            type="checkbox"
                                            name="chk-adr"
                                            onChange={(e) => selectedClick(e, index)}
                                            checked={item.checked}
                                            value={item.idadr}
                                        />
                                        <label>{item.adr}</label>
                                    </div>
                                ))}
                            </div>
                            <div className="filtro-sucursal">
                                <div className="title-sucursal">SUCURSAL</div>
                                {sucursalFiltrada.map((item, index) => (
                                    <div key={`${item}-${index}`} className="chk-groups">
                                        <input
                                            type="checkbox"
                                            name="chk-sucursal"
                                            className="my-checkbox"
                                            onChange={(e) => selectedClick(e, index)}
                                            checked={item.checked}
                                            value={item.idsucursal}
                                        />
                                        <label onClick={labelclick}>{item.sucursal}</label>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="mdlFiltros-modal-acciones" />
                    </div>
                </PlantillaScreen>
            </div>
        </div>
    );
};

export default FiltroCondonacionesGlobal;
